import {
	Button,
	PanelRow,
	PanelBody,
	ToggleControl,
	Dropdown,
	Popover,
	SelectControl,
	RangeControl,
	Panel,
	DropdownMenu,
	ColorPicker,
	ColorPalette,
	ToolsPanelItem,
	ComboboxControl,
	MenuGroup,
	MenuItem,
	TextareaControl,
	Spinner,
	Tooltip,
	DateTimePicker,
	DatePicker,
} from "@wordpress/components";
import { applyFilters } from "@wordpress/hooks";
import apiFetch from "@wordpress/api-fetch";

import { __experimentalInputControl as InputControl } from "@wordpress/components";
import {
	useState,
	useEffect,
	Component,
	RawHTML,
	////
	useRef,
	////
} from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Icon, close } from "@wordpress/icons";
import CBDropdown from "../../components/dropdown";
import PGtoggle from "../toggle";
function Html(props) {
	if (!props.warn) {
		return null;
	}
	const [animateOn, setanimateOn] = useState(props.animateOn);
	var [rules, setrules] = useState(
		animateOn?.rules == null || animateOn?.rules == undefined ? [] : animateOn.rules
	);
	useEffect(() => {
		props.onChange(animateOn);
	}, [animateOn]);
	useEffect(() => {
		var animateOnX = { ...animateOn };
		animateOnX.rules = rules;
		setanimateOn(animateOnX);
	}, [rules]);
	var animateListArgsBasic = {
		backInDown: { label: __("backInDown", "pickplugins-product-slider-for-fluentcart"), value: "backInDown" },
		backInLeft: { label: __("backInLeft", "pickplugins-product-slider-for-fluentcart"), value: "backInLeft" },
		backInRight: {
			label: __("backInRight", "pickplugins-product-slider-for-fluentcart"),
			value: "backInRight",
			//isPro: true,
		},
		backInUp: {
			label: __("backInUp", "pickplugins-product-slider-for-fluentcart"),
			value: "backInUp",
			//isPro: true,
		},
		bounceIn: { label: __("bounceIn", "pickplugins-product-slider-for-fluentcart"), value: "bounceIn" },
		bounceInDown: {
			label: __("bounceInDown", "pickplugins-product-slider-for-fluentcart"),
			value: "bounceInDown",
			//isPro: true,
		},
		bounceInLeft: {
			label: __("bounceInLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "bounceInLeft",
			//isPro: true,
		},
		bounceInRight: {
			label: __("bounceInRight", "pickplugins-product-slider-for-fluentcart"),
			value: "bounceInRight",
			//isPro: true,
		},
		bounceInUp: {
			label: __("bounceInUp", "pickplugins-product-slider-for-fluentcart"),
			value: "bounceInUp",
			//isPro: true,
		},
		fadeIn: { label: __("fadeIn", "pickplugins-product-slider-for-fluentcart"), value: "fadeIn" },
		fadeInDown: {
			label: __("fadeInDown", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInDown",
			//isPro: true,
		},
		fadeInDownBig: {
			label: __("fadeInDownBig", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInDownBig",
			//isPro: true,
		},
		fadeInLeft: {
			label: __("fadeInLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInLeft",
			//isPro: true,
		},
		fadeInLeftBig: {
			label: __("fadeInLeftBig", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInLeftBig",
			//isPro: true,
		},
		fadeInRight: {
			label: __("fadeInRight", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInRight",
			//isPro: true,
		},
		fadeInRightBig: {
			label: __("fadeInRightBig", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInRightBig",
			//isPro: true,
		},
		fadeInUp: {
			label: __("fadeInUp", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInUp",
			//isPro: true,
		},
		fadeInUpBig: {
			label: __("fadeInUpBig", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInUpBig",
			//isPro: true,
		},
		fadeInTopLeft: {
			label: __("fadeInTopLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInTopLeft",
			//isPro: true,
		},
		fadeInTopRight: {
			label: __("fadeInTopRight", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInTopRight",
			//isPro: true,
		},
		fadeInBottomRight: {
			label: __("fadeInBottomRight", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInBottomRight",
			//isPro: true,
		},
		fadeInBottomLeft: {
			label: __("fadeInBottomLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeInBottomLeft",
			//isPro: true,
		},
		rotateIn: { label: __("rotateIn", "pickplugins-product-slider-for-fluentcart"), value: "rotateIn" },
		rotateInDownLeft: {
			label: __("rotateInDownLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "rotateInDownLeft",
			//isPro: true,
		},
		rotateInDownRight: {
			label: __("rotateInDownRight", "pickplugins-product-slider-for-fluentcart"),
			value: "rotateInDownRight",
			//isPro: true,
		},
		rotateInUpLeft: {
			label: __("rotateInUpLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "rotateInUpLeft",
			//isPro: true,
		},
		rotateInUpRight: {
			label: __("rotateInUpRight", "pickplugins-product-slider-for-fluentcart"),
			value: "rotateInUpRight",
			//isPro: true,
		},
		zoomIn: { label: __("zoomIn", "pickplugins-product-slider-for-fluentcart"), value: "zoomIn", isPro: true },
		zoomInDown: {
			label: __("zoomInDown", "pickplugins-product-slider-for-fluentcart"),
			value: "zoomInDown",
			//isPro: true,
		},
		zoomInLeft: {
			label: __("zoomInLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "zoomInLeft",
			//isPro: true,
		},
		zoomInRight: {
			label: __("zoomInRight", "pickplugins-product-slider-for-fluentcart"),
			value: "zoomInRight",
			//isPro: true,
		},
		zoomInUp: {
			label: __("zoomInUp", "pickplugins-product-slider-for-fluentcart"),
			value: "zoomInUp",
			//isPro: true,
		},
		slideInDown: {
			label: __("slideInDown", "pickplugins-product-slider-for-fluentcart"),
			value: "slideInDown",
			//isPro: true,
		},
		slideInLeft: {
			label: __("slideInLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "slideInLeft",
			//isPro: true,
		},
		slideInRight: {
			label: __("slideInRight", "pickplugins-product-slider-for-fluentcart"),
			value: "slideInRight",
			//isPro: true,
		},
		slideInUp: {
			label: __("slideInUp", "pickplugins-product-slider-for-fluentcart"),
			value: "slideInUp",
			//isPro: true,
		},
		backOutDown: {
			label: __("backOutDown", "pickplugins-product-slider-for-fluentcart"),
			value: "backOutDown",
		},
		backOutLeft: {
			label: __("backOutLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "backOutLeft",
		},
		backOutRight: {
			label: __("backOutRight", "pickplugins-product-slider-for-fluentcart"),
			value: "backOutRight",
			//isPro: true,
		},
		backOutUp: {
			label: __("backOutUp", "pickplugins-product-slider-for-fluentcart"),
			value: "backOutUp",
			//isPro: true,
		},
		bounceOut: { label: __("bounceOut", "pickplugins-product-slider-for-fluentcart"), value: "bounceOut" },
		bounceOutDown: {
			label: __("bounceOutDown", "pickplugins-product-slider-for-fluentcart"),
			value: "bounceOutDown",
			//isPro: true,
		},
		bounceOutLeft: {
			label: __("bounceOutLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "bounceOutLeft",
			//isPro: true,
		},
		bounceOutRight: {
			label: __("bounceOutRight", "pickplugins-product-slider-for-fluentcart"),
			value: "bounceOutRight",
			//isPro: true,
		},
		bounceOutUp: {
			label: __("bounceOutUp", "pickplugins-product-slider-for-fluentcart"),
			value: "bounceOutUp",
			//isPro: true,
		},
		fadeOut: { label: __("fadeOut", "pickplugins-product-slider-for-fluentcart"), value: "fadeOut" },
		fadeOutDown: {
			label: __("fadeOutDown", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutDown",
			//isPro: true,
		},
		fadeOutDownBig: {
			label: __("fadeOutDownBig", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutDownBig",
			//isPro: true,
		},
		fadeOutLeft: {
			label: __("fadeOutLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutLeft",
			//isPro: true,
		},
		fadeOutLeftBig: {
			label: __("fadeOutLeftBig", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutLeftBig",
			//isPro: true,
		},
		fadeOutRight: {
			label: __("fadeOutRight", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutRight",
			//isPro: true,
		},
		fadeOutRightBig: {
			label: __("fadeOutRightBig", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutRightBig",
			//isPro: true,
		},
		fadeOutUp: {
			label: __("fadeOutUp", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutUp",
			//isPro: true,
		},
		fadeOutUpBig: {
			label: __("fadeOutUpBig", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutUpBig",
			//isPro: true,
		},
		fadeOutTopLeft: {
			label: __("fadeOutTopLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutTopLeft",
			//isPro: true,
		},
		fadeOutTopRight: {
			label: __("fadeOutTopRight", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutTopRight",
			//isPro: true,
		},
		fadeOutBottomRight: {
			label: __("fadeOutBottomRight", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutBottomRight",
			//isPro: true,
		},
		fadeOutBottomLeft: {
			label: __("fadeOutBottomLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "fadeOutBottomLeft",
			//isPro: true,
		},
		rotateOut: { label: __("rotateOut", "pickplugins-product-slider-for-fluentcart"), value: "rotateOut" },
		rotateOutDownLeft: {
			label: __("rotateOutDownLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "rotateOutDownLeft",
			//isPro: true,
		},
		rotateOutDownRight: {
			label: __("rotateOutDownRight", "pickplugins-product-slider-for-fluentcart"),
			value: "rotateOutDownRight",
			//isPro: true,
		},
		rotateOutUpLeft: {
			label: __("rotateOutUpLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "rotateOutUpLeft",
			//isPro: true,
		},
		rotateOutUpRight: {
			label: __("rotateOutUpRight", "pickplugins-product-slider-for-fluentcart"),
			value: "rotateOutUpRight",
			//isPro: true,
		},
		zoomOut: {
			label: __("zoomOut", "pickplugins-product-slider-for-fluentcart"),
			value: "zoomOut",
			//isPro: true,
		},
		zoomOutDown: {
			label: __("zoomOutDown", "pickplugins-product-slider-for-fluentcart"),
			value: "zoomOutDown",
			//isPro: true,
		},
		zoomOutLeft: {
			label: __("zoomOutLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "zoomOutLeft",
			//isPro: true,
		},
		zoomOutRight: {
			label: __("zoomOutRight", "pickplugins-product-slider-for-fluentcart"),
			value: "zoomOutRight",
			//isPro: true,
		},
		zoomOutUp: {
			label: __("zoomOutUp", "pickplugins-product-slider-for-fluentcart"),
			value: "zoomOutUp",
			//isPro: true,
		},
		slideOutDown: {
			label: __("slideOutDown", "pickplugins-product-slider-for-fluentcart"),
			value: "slideOutDown",
			//isPro: true,
		},
		slideOutLeft: {
			label: __("slideOutLeft", "pickplugins-product-slider-for-fluentcart"),
			value: "slideOutLeft",
			//isPro: true,
		},
		slideOutRight: {
			label: __("slideOutRight", "pickplugins-product-slider-for-fluentcart"),
			value: "slideOutRight",
			//isPro: true,
		},
		slideOutUp: {
			label: __("slideOutUp", "pickplugins-product-slider-for-fluentcart"),
			value: "slideOutUp",
			//isPro: true,
		},
	};
	let animateListArgs = applyFilters(
		"AnimateOnArgs",
		animateListArgsBasic
	);

	var events = {
		load: { label: __("Page Load", "pickplugins-product-slider-for-fluentcart"), value: "load" },
		scroll: { label: __("Scroll To", "pickplugins-product-slider-for-fluentcart"), value: "scroll" },
		mouseover: { label: __("Mouse Over", "pickplugins-product-slider-for-fluentcart"), value: "mouseover" },
		mouseout: { label: __("Mouse Out", "pickplugins-product-slider-for-fluentcart"), value: "mouseout" },
		click: { label: __("Click Element", "pickplugins-product-slider-for-fluentcart"), value: "click" },
	}


	var RemoveAnimateOnGroup = function ({ title, index }) {
		return (
			<>
				<Icon icon={close} onClick={(ev) => {
					var rulesX = [...rules];
					rulesX.splice(index, 1);
					setrules(rulesX);
				}} />
				<span>{title}</span>
			</>
		);
	};
	return (
		<div className="relative">
			<PanelRow className="my-3">
				<div
					// className="bg-gray-700 hover:bg-gray-600 p-2 px-4 text-white inline-block cursor-pointer rounded-sm"
					className="flex gap-2 justify-center my-2 cursor-pointer py-2 px-4 capitalize  bg-gray-700	 text-white font-medium rounded hover:bg-gray-600	 hover:text-white focus:outline-none focus:bg-gray-600	"
					onClick={(ev) => {
						var rulesX = [...rules];
						rulesX.push({ event: "mouseover", title: "", animationName: "backInDown", eventTarget: '.item', duration: "", delay: "", });
						setrules(rulesX);
					}}>
					{__("Add", "pickplugins-product-slider-for-fluentcart")}
				</div>
			</PanelRow>
			<div className="my-4">
				{rules.map((group, groupIndex) => {
					return (
						<PGtoggle
							title={
								<RemoveAnimateOnGroup title={events[group.event]?.label + " - " + animateListArgs[group.animationName]?.label} index={groupIndex} />
							}
							initialOpen={false} key={groupIndex} >
							<PanelRow className="my-3">
								<label>Event?</label>
								<CBDropdown
									position="bottom right"
									variant="secondary"
									buttonTitle={
										group.event == undefined
											? __("Choose", "pickplugins-product-slider-for-fluentcart")
											: group.event
									}
									options={events}
									onChange={(option, index) => {
										var rulesX = [...rules];
										rulesX[groupIndex]["event"] = option.value;
										setrules(rulesX);
									}}
									values=""></CBDropdown>
							</PanelRow>
							<PanelRow>
								<label htmlFor="" >
									{__("Target?", "pickplugins-product-slider-for-fluentcart")}
								</label>
								<InputControl
									className=""
									value={group.eventTarget}
									onChange={(newVal) => {
										var rulesX = [...rules];
										rulesX[groupIndex]["eventTarget"] = newVal;
										setrules(rulesX);
									}}
								/>
							</PanelRow>


							<PanelRow>
								<label htmlFor="" >
									{__("Animation", "pickplugins-product-slider-for-fluentcart")}
								</label>
								<CBDropdown
									position="bottom right"
									variant="secondary"
									buttonTitle={
										animateListArgs[group.animationName] ==
											undefined
											? __("Choose", "pickplugins-product-slider-for-fluentcart")
											: animateListArgs[group.animationName].label
									}
									options={animateListArgs}
									onChange={(option, index) => {
										var rulesX = [...rules];
										rulesX[groupIndex]["animationName"] = option.value;
										setrules(rulesX);
									}}
									values=""></CBDropdown>
							</PanelRow>
							{/* <PanelRow>
								<label htmlFor="" >
									{__("Duration", "pickplugins-product-slider-for-fluentcart")}
								</label>
								<InputControl
									className=""
									value={group.duration}
									onChange={(newVal) => {
										var rulesX = [...rules];
										rulesX[groupIndex]["duration"] = newVal;
										setrules(rulesX);
									}}
								/>
							</PanelRow>
							<PanelRow>
								<label htmlFor="" >
									{__("Delay", "pickplugins-product-slider-for-fluentcart")}
								</label>
								<InputControl
									className=""
									value={group.delay}
									onChange={(newVal) => {
										var rulesX = [...rules];
										rulesX[groupIndex]["delay"] = newVal;
										setrules(rulesX);
									}}
								/>
							</PanelRow> */}
						</PGtoggle>
					);
				})}
			</div>
		</div>
	);
}
class CBAnimateOn extends Component {
	constructor(props) {
		super(props);
		this.state = { showWarning: true };
		this.handleToggleClick = this.handleToggleClick.bind(this);
	}
	handleToggleClick() {
		this.setState((state) => ({
			showWarning: !state.showWarning,
		}));
	}
	render() {
		const {
			position,
			variant,
			btnClass,
			searchPlaceholder,
			options, //[{"label":"Select..","icon":"","value":""}]
			buttonTitle,
			onChange,
			animateOn,
			values,
			value,
		} = this.props;
		return (
			<div>
				<Html
					value={value}
					position={position}
					searchPlaceholder={searchPlaceholder}
					btnClass={btnClass}
					variant={variant}
					options={options}
					buttonTitle={buttonTitle}
					onChange={onChange}
					animateOn={animateOn}
					warn={this.state.showWarning}
				/>
			</div>
		);
	}
}
export default CBAnimateOn;
